export const DEFAULT_OPTION_LABEL = 'label';
export const DEFAULT_OPTION_VALUE = 'value';
export const CHECKBOX_SIZE = 14;
